import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Cross-feature visibility of the map pages' right side panel (the 440px "Veículos/Locais" panel on
 * /monitoring and "Trajeto do veículo" on /tracking). Lives in hooks (not a single feature store)
 * because both the page that owns the panel and the floating cards that hug it — across modules — read
 * the same flag. Each map page is the source of truth: it drives the flag on toggle and resets it on
 * unmount so a collapsed panel never leaks into the next page.
 */
interface RightPanelState {
  isRightPanelHidden: boolean;
  toggleRightPanel: () => void;
  setRightPanelHidden: (hidden: boolean) => void;
  reset: () => void;
}

const useRightPanelStore = create<RightPanelState, [['zustand/devtools', never]]>(
  devtools(
    (set) => ({
      isRightPanelHidden: false,
      toggleRightPanel: () => set((state) => ({ isRightPanelHidden: !state.isRightPanelHidden })),
      setRightPanelHidden: (hidden) => set({ isRightPanelHidden: hidden }),
      reset: () => set({ isRightPanelHidden: false }),
    }),
    { name: 'useRightPanelStore' }
  )
);

export default useRightPanelStore;
